import React, { FC } from 'react'
import { StyledTNLink } from './TNLink.styled'
import { DisplayProperty } from 'csstype'

export interface TNLinkProps {
    color?: string
    fontWeight?: number
    display?: DisplayProperty
    disabled?: boolean
    marginBottom?: number
    width?: string
    underline?: boolean
    onClick: () => void
}

export const TNLink: FC<TNLinkProps> = (props) => {
    return <StyledTNLink {...props}>{props.children}</StyledTNLink>
}
